var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`position: relative; height: 100%; background-color: ${_vm.workpackage_bg_hex}; fill: ${_vm.workpackage_fg_hex}`)},[(_vm.location !== 'ProjectWallet')?_c('WorkPackageHead',{attrs:{"head":{
        token: _vm.workpackage.token,
        name: _vm.workpackage.name,
        icon: _vm.workpackage.icon,
        area: _vm.backlog ? _vm.wbline.name : _vm.taktarea.name,
        status_done_count: _vm.$store.state.Ultra.status_array.findIndex(status => status.name === _vm.workpackage.status),
        status_is_stop: _vm.workpackage.stop_status,
      },"background_color":_vm.workpackage_bg_hex,"foreground_color":_vm.workpackage_fg_hex,"readonly":_vm.location.includes('HistProjectTaktPlan')},on:{"selectStatus":function($event){_vm.updateUObject({
        url: _vm.workpackage_url,
        url_suffix: $event.tooltip.toLowerCase() !== 'stop' ? '/status' : '/stopstatus',
        update: $event.tooltip.toLowerCase() !== 'stop' ?
          { status: _vm.workpackage.status !== $event.tooltip.toLowerCase() ? $event.tooltip.toLowerCase() : 'none' }
          :
          { stop_status: _vm.workpackage.stop_status !== 'none' ? 'none' : 'stop' }
      })},"selectStopStatus":function($event){_vm.updateUObject({
        url: _vm.workpackage_url,
        url_suffix: '/stopstatus',
        update: { stop_status: _vm.workpackage.stop_status !== 'none' ? 'none' : 'stop' }
      }).then(() => {
        if ($event !== ''){
          if(_vm.backlog){
            _vm.createLogListComment({
              backlog: true,
              project_id: _vm.project_id,
              wbgroup_id: _vm.wbgroup_id,
              wbline_id: _vm.wbline_id,
              workpackage_id: _vm.workpackage.id,
              data: {
                comment: $event,
              },
            })
          }else{
            _vm.createLogListComment({
              project_id: _vm.project_id,
              train_id: _vm.train_id,
              taktarea_id: _vm.taktarea_id,
              twaggon_id: _vm.twaggon_id,
              workpackage_id: _vm.workpackage.id,
              data: {
                comment: $event,
              },
            })
          }
        }
      })},"clickHeader":function($event){_vm.location.includes('HistProjectTaktPlan')
        ? _vm.$router.push({ name: 'HistProjectTaktPlan', params: { nav_back: _vm.$route.params.nav_back} })
        : _vm.$router.push({ name: 'ProjectTaktPlan', params: { nav_back: _vm.$route.params.nav_back} })}}}):_vm._e(),_c('div',{class:`workpackage-rework`,style:(_vm.location === 'ProjectWallet' ? 'height: 100%' : (_vm.isMobile ? `height: calc(${_vm.mobile_height}px - 70px - 35px - 6px)` : ''))},[_c('div',{staticClass:"workpackage-content-container",style:(_vm.location === 'ProjectWallet' || _vm.isMobile ? 'width: 100%; height: calc(100% + 5px)' : ''),attrs:{"id":"ultra-container"}},[(_vm.backlog)?_c('div',{style:(`position: relative; display: flex; align-items: center; justify-content: space-between; height: 40px; color: ${_vm.workpackage.textcolor};`)},[_c('div',[_vm._v("Date: "+_vm._s(_vm.workpackage.position !== -1 ? `${_vm.getWBWorkpackageDate(_vm.workpackage, _vm.project_id).start} - ${_vm.getWBWorkpackageDate(_vm.workpackage, _vm.project_id).end}` : 'no date set'))]),(_vm.isEditMode)?_c('v-btn',{attrs:{"icon":"","small":"","color":_vm.workpackage.textcolor},on:{"click":function($event){_vm.show_date_picker = true}}},[_c('v-icon',[_vm._v("today")])],1):_vm._e(),(_vm.show_date_picker)?_c('BacklogDatePicker',{attrs:{"date":_vm.getWBWorkpackageDate(_vm.workpackage, _vm.project_id),"wbworkpackage_position":_vm.workpackage.position},on:{"clickOutside":function($event){_vm.show_date_picker = false},"clickClose":function($event){_vm.show_date_picker = false},"updatePosition":function($event){return _vm.updateUObject({
            url: _vm.workpackage_url,
            update: {
              position: $event
            }
          })},"updateLength":function($event){return _vm.updateUObject({
            url: _vm.workpackage_url,
            update: {
              length: $event
            }
          })},"clickRemove":function($event){return _vm.updateUObject({
            url: _vm.workpackage_url,
            update: {
              position: -1,
              length: 1,
            }
          })}}}):_vm._e()],1):_vm._e(),_c('CollapsableCategory',{attrs:{"value":"Description","color":_vm.workpackage_fg_hex},scopedSlots:_vm._u([{key:"content",fn:function({ is_collapsed, }){return [_c('TransitionAccordion',[(!is_collapsed && _vm.isEditMode)?_c('div',[_c('TText',{attrs:{"text":_vm.workpackage.name,"small":"","font_weight":500,"color":_vm.workpackage_fg_hex}}),_c('TText',{attrs:{"text":_vm.backlog ? _vm.wbline.name : _vm.taktarea.name,"small":"","font_weight":500,"color":_vm.workpackage_fg_hex}}),_c('TextArea',{attrs:{"value":_vm.workpackage.description,"label":_vm.$t('WorkpackageRework.Info.Description'),"placeholder":`Describe the WORK.package`,"max_char_count":_vm.isEditMode ? 500 : '',"height":170,"background_color":_vm.workpackage_bg_hex,"foreground_color":_vm.workpackage_fg_hex,"is_disabled":!_vm.isEditMode || !_vm.hasProjectPermissionForTWP({ project_id: _vm.project_id, action: 'Update', entity: 'Work Packages', twp: _vm.workpackage.id })},on:{"change":function($event){_vm.backlog ?
                _vm.updateUObject({
                  url: _vm.workpackage_url,
                  update: {
                    description: $event
                  }
                })
                :
                _vm.requestSnackbarUpdate({
                  url: _vm.workpackage_url,
                  update: {
                    description: $event
                  },
                  selector: 'target',
                }).then((payload) => {
                  _vm.updateUObject(payload);
                })}}})],1):_vm._e()]),_c('TransitionAccordion',[(!is_collapsed && !_vm.isEditMode)?_c('div',[_c('TText',{attrs:{"text":_vm.workpackage.name,"small":"","font_weight":500,"color":_vm.workpackage_fg_hex}}),_c('TText',{attrs:{"text":_vm.backlog ? _vm.wbline.name : _vm.taktarea.name,"small":"","font_weight":500,"color":_vm.workpackage_fg_hex}}),_c('TText',{attrs:{"text":_vm.workpackage.description,"small":"","color":_vm.workpackage_fg_hex}})],1):_vm._e()])]}}])}),_c('CollapsableCategory',{attrs:{"value":"Steps","color":_vm.workpackage_fg_hex},scopedSlots:_vm._u([{key:"content",fn:function({ is_collapsed }){return [_c('WorkPackageStepCategoryList',{key:`additionalinformation${_vm.update_additional_info}`,attrs:{"items":[
            {
              step_type: 'Logistic',
              is_disabled: !_vm.hasPermission('TLogisticStep READ'),
              progress: _vm.calcStepProgress('logistic')
            },
            {
              step_type: 'Design',
              is_disabled: !_vm.hasPermission('TDesignStep READ'),
              progress: _vm.calcStepProgress('design')
            },
            {
              step_type: 'Work',
              is_disabled: !_vm.hasPermission('TWorkStep READ'),
              progress: _vm.calcStepProgress('work')
            },
            {
              step_type: 'Quality',
              is_disabled: !_vm.hasPermission('TQualityStep READ'),
              progress: _vm.calcStepProgress('quality')
            },
            {
              step_type: 'Defect',
              is_disabled: !_vm.hasPermission('TDefectStep READ'),
              progress: _vm.calcStepProgress('defect')
            },
            {
              step_type: 'Handover',
              is_disabled: !_vm.hasPermission('THandoverStep READ'),
              progress: _vm.calcStepProgress('handover')
            },
            {
              step_type: 'Material',
              is_disabled: !_vm.hasPermission('TMaterialStep READ'),
              progress: _vm.calcStepProgress('material')
            },
            {
              icon: 'mdi-crane',
              step_type: 'Machine',
              is_disabled: !_vm.hasPermission('TMachineStep READ'),
              progress: _vm.calcStepProgress('machine')
            },
            /* {
              icon: 'mdi-hammer-screwdriver',
              step_type: 'Tool',
              progress: { done_count: 0, task_count: 0},
            },
            {
              icon: 'mdi-signal-variant',
              step_type: 'Sensor',
              progress: { done_count: 0, task_count: 0},
            },
            {
              icon: 'mdi-robot-happy-outline',
              step_type: 'Robotic',
              progress: { done_count: 0, task_count: 0},
            }, */
          ],"has_lines":true,"is_collapsed":is_collapsed,"background_color":_vm.workpackage_bg_hex,"foreground_color":_vm.workpackage_fg_hex,"items_per_row":5},on:{"stepsClick":function($event){return _vm.$router.push({ name: `${_vm.location}WorkPackage${$event}Steps`, params: { nav_back: _vm.$route.params.nav_back} })}}})]}}])}),(!_vm.location.includes('HistProjectTaktPlan'))?_c('CollapsableCategory',{attrs:{"value":"Time_Record","color":_vm.workpackage_fg_hex},scopedSlots:_vm._u([{key:"content",fn:function({ is_collapsed }){return [(!_vm.location.includes('HistProjectTaktPlan'))?_c('TimeRecord',{attrs:{"equations":[
            {
              description: 'On Site',
              id: 'On Site',
              description_suffix: _vm.hasCalendar(_vm.project_id) ? `(${_vm.selected_day === 'TAKT' ? `${_vm.$t('WorkpackageRework.Info.TimeRecord.TAKT')}` : _vm.daily_report_days.find(day => day.description === _vm.selected_day).takt_date})` : '(Missing Calendar!)',
              /* label (string), label_size (number), icon (string), text (string), operator (string) */
              elements: [
                {
                  label: 'Time Effort', id: 'Time Effort', label_suffix: _vm.selected_day === 'TAKT' ? '∑' : '', icon: 'speedometer', value: _vm.selected_report.time_effort, unit: 'Mh',
                  input_type: 'number', input_mode: 'decimal', operator: '',
                  is_disabled: true
                },
                { icon: '', value: '', operator: _vm.selected_day === 'TAKT' ? ' ' : '/' },
                {
                  label: 'Manpower', id: 'Manpower', label_suffix: _vm.selected_day === 'TAKT' ? '⌀' : '', icon: 'person-standing', value: _vm.selected_report.manpower, unit: 'M',
                  input_type: 'number', input_mode: 'decimal', operator: '',
                  is_disabled: _vm.hasCalendar(_vm.project_id) && _vm.hasProjectPermissionForTWP({ project_id: _vm.project_id, action: 'Update', entity: 'Work Packages', twp: _vm.workpackage.id }) ? false : true
                },
                { icon: '', value: '', operator: _vm.selected_day === 'TAKT' ? ' ' : '=' },
                {
                  label: 'Duration', id: 'Duration', label_suffix: _vm.selected_day === 'TAKT' ? '∑' : '', icon: 'stopwatch', value: _vm.selected_report.duration, unit: 'h',
                  input_type: 'number', input_mode: 'decimal', operator: '',
                  is_disabled: _vm.hasCalendar(_vm.project_id) && _vm.hasProjectPermissionForTWP({ project_id: _vm.project_id, action: 'Update', entity: 'Work Packages', twp: _vm.workpackage.id }) ? false : true
                },
              ],
            },
            {
              description: 'Plan',
              id: 'Plan',
              description_suffix: `(${_vm.$t('WorkpackageRework.Info.TimeRecord.TAKT')})`,
              /* label (string), label_size (number), icon (string), value (string), operator (string) */
              elements: [
                { label: 'Time Effort', id: 'Time Effort', icon: 'speedometer', value: _vm.workpackage.time_effort_source === 'time_effort_planned' ? _vm.workpackage.time_effort_planned : (_vm.workpackage[`${_vm.prefix}worksteps`].length === 0 ? _vm.workpackage.time_effort_steps : _vm.calcAllWorkStepsTotal({ workpackage: _vm.workpackage, prefix: `${_vm.histprefix}${_vm.prefix}` }).value), unit: 'Mh', input_type: 'number', operator: '', is_disabled: true },
                { icon: '', value: '', operator: '/' },
                { label: 'Manpower', id: 'Manpower', icon: 'person-standing', value: _vm.workpackage.manpower_planned, unit: 'M', input_type: 'number', input_mode: 'decimal', operator: '', is_disabled: !_vm.isEditMode || !_vm.hasProjectPermissionForTWP({ project_id: _vm.project_id, action: 'Update', entity: 'Work Packages', twp: _vm.workpackage.id }) },
                { icon: '', value: '', operator: '=' },
                { label: 'Duration', id: 'Duration', icon: 'stopwatch', value: _vm.workpackage.manpower_planned > 0 ? (Math.round(((_vm.workpackage.time_effort_source === 'time_effort_planned' ? _vm.workpackage.time_effort_planned : (_vm.workpackage[`${_vm.prefix}worksteps`].length === 0 ? _vm.workpackage.time_effort_steps : _vm.calcAllWorkStepsTotal({ workpackage: _vm.workpackage, prefix: `${_vm.histprefix}${_vm.prefix}` }).value)) / _vm.workpackage.manpower_planned) * 100) / 100) : 0, unit: 'h', input_type: 'number', operator: '', is_disabled: true },
              ],
            },
            {
              description: 'Time Effort Plan Source',
              id: 'Time Effort Plan Source',
              /* label (string), label_size (number), icon (string), value (string), operator (string) */
              elements: [
                { label: 'WORK.steps', id: 'Worksteps', icon: 'speedometer', value: _vm.workpackage[`${_vm.prefix}worksteps`].length === 0 ? _vm.workpackage.time_effort_steps : _vm.calcAllWorkStepsTotal({ workpackage: _vm.workpackage, prefix: `${_vm.histprefix}${_vm.prefix}` }).value, unit: 'Mh', input_type: 'number', operator: '', is_disabled: true },
                { label: 'SourceButton', id: 'SourceButton', button: true, is_selected: _vm.workpackage.time_effort_source === 'time_effort_steps', icon: _vm.workpackage.time_effort_source === 'time_effort_steps' ? 'check' : false, value: 'time_effort_steps', width: '26', is_disabled: !_vm.isEditMode || !_vm.hasProjectPermissionForTWP({ project_id: _vm.project_id, action: 'Update', entity: 'Work Packages', twp: _vm.workpackage.id }) },
                { label: 'SourceButton', id: 'SourceButton', button: true, is_selected: _vm.workpackage.time_effort_source === 'time_effort_planned', icon: _vm.workpackage.time_effort_source === 'time_effort_planned' ? 'check' : false, value: 'time_effort_planned', width: '26', is_disabled: !_vm.isEditMode || !_vm.hasProjectPermissionForTWP({ project_id: _vm.project_id, action: 'Update', entity: 'Work Packages', twp: _vm.workpackage.id }) },
                { label: 'WORK.package', id: 'WORKpackage', icon: 'speedometer', value: _vm.workpackage.time_effort_planned, unit: 'Mh', input_type: 'number', input_mode: 'decimal', operator: '', is_disabled: !_vm.isEditMode || !_vm.hasProjectPermissionForTWP({ project_id: _vm.project_id, action: 'Update', entity: 'Work Packages', twp: _vm.workpackage.id }) },
              ],
            },
          ],"time_squares":_vm.daily_report_days,"selected_day":_vm.selected_day,"is_collapsed":is_collapsed,"collapsed_equations":[
            {
              description: 'On Site',
              id: 'On Site',
              description_suffix: _vm.hasCalendar(_vm.project_id) ? `(${_vm.selected_day === 'TAKT' ? `${_vm.$t('WorkpackageRework.Info.TimeRecord.TAKT')}` : _vm.daily_report_days.find(day => day.description === _vm.selected_day).takt_date})` : '(Missing Calendar!)',
              /* label (string), label_size (number), icon (string), text (string), operator (string) */
              elements: [
                { label: 'SourceButton', id: 'SourceButton', description: _vm.selected_day, button: true, is_selected: true, width: '42', height: '42', not_clickable: true },
                { label: 'Manpower', id: 'Manpower', icon: 'person-standing', value: _vm.selected_report.manpower, unit: 'M', input_type: 'number', input_mode: 'decimal', operator: '', is_disabled: _vm.hasCalendar(_vm.project_id) ? false : true },
                { label: 'Duration', id: 'Duration', icon: 'stopwatch', value: _vm.selected_report.duration, unit: 'h', input_type: 'number', input_mode: 'decimal', operator: '', is_disabled: _vm.hasCalendar(_vm.project_id) ? false : true },
              ],
            },
            {
              description: 'Plan',
              id: 'Plan',
              description_suffix: `(${_vm.$t('WorkpackageRework.Info.TimeRecord.TAKT')})`,
              /* label (string), label_size (number), icon (string), value (string), operator (string) */
              elements: [
                { label: 'Manpower', id: 'Manpower', icon: 'person-standing', value: _vm.workpackage.manpower_planned, unit: 'M', input_type: 'number', operator: '', is_disabled: !_vm.isEditMode || !_vm.hasProjectPermissionForTWP({ project_id: _vm.project_id, action: 'Update', entity: 'Work Packages', twp: _vm.workpackage.id }) },
                { label: 'Duration', id: 'Duration', icon: 'stopwatch', value: _vm.workpackage.manpower_planned > 0 ? (Math.round(((_vm.workpackage.time_effort_source === 'time_effort_planned' ? _vm.workpackage.time_effort_planned : (_vm.workpackage[`${_vm.prefix}worksteps`].length === 0 ? _vm.workpackage.time_effort_steps : _vm.calcAllWorkStepsTotal({ workpackage: _vm.workpackage, prefix: `${_vm.histprefix}${_vm.prefix}` }).value)) / _vm.workpackage.manpower_planned) * 100) / 100) : 0, unit: 'h', input_type: 'number', operator: '', is_disabled: true },
              ],
            },
          ],"items_per_row":5,"background_color":_vm.workpackage_bg_hex,"foreground_color":_vm.workpackage_fg_hex},on:{"clickDay":function($event){_vm.selected_day = $event},"changeManpowerPlan":function($event){_vm.backlog ?
              _vm.updateUObject({
                url: _vm.workpackage_url,
                update: {
                  manpower_planned: parseFloat($event)
                }
              })
              :
              _vm.requestSnackbarUpdate({
                url: _vm.workpackage_url,
                update: {
                  manpower_planned: parseFloat($event)
                },
                selector: 'target'
              }).then((payload) => {
                _vm.updateUObject(payload);
              })},"changeWORKpackageTimeEffortPlanSource":function($event){_vm.backlog ?
              _vm.updateUObject({
                url: _vm.workpackage_url,
                update: {
                  time_effort_planned: parseFloat($event)
                }
              })
              :
              _vm.requestSnackbarUpdate({
                url: _vm.workpackage_url,
                update: {
                  time_effort_planned: parseFloat($event)
                },
                selector: 'target'
              }).then((payload) => {
                _vm.updateUObject(payload);
              })},"changeManpowerOnSite":function($event){_vm.changeDailyReport({ prop: 'manpower', value: parseFloat($event) })},"changeDurationOnSite":function($event){_vm.changeDailyReport({ prop: 'duration', value: parseFloat($event) })},"clickSourceButtonTimeEffortPlanSource":function($event){_vm.backlog ?
              _vm.updateUObject({
                url: _vm.workpackage_url,
                update: {
                  time_effort_source: $event
                }
              })
              :
              _vm.requestSnackbarUpdate({
                url: _vm.workpackage_url,
                update: {
                  time_effort_source: $event
                },
                selector: 'target'
              }).then((payload) => {
                _vm.updateUObject(payload);
              })}}}):_vm._e()]}}],null,false,1676412452)}):_vm._e(),(!_vm.location.includes('HistProjectTaktPlan'))?_c('CollapsableCategory',{attrs:{"value":"Extras","color":_vm.workpackage_fg_hex,"is_disabled":true},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('WorkPackageWidgetList',{attrs:{"widgets":_vm.prepared_widgets,"items_per_row":5,"background_color":_vm.workpackage_bg_hex,"foreground_color":_vm.workpackage_fg_hex,"is_small_icons":true},on:{"setActive":function($event){_vm.$router.push({
              name: _vm.$route.name.includes($event.route_name)
                ? `${_vm.location}WorkPackageInfo`
                : `${_vm.location}${$event.route_name}`,
              params: { nav_back: _vm.$route.params.nav_back },
            })}}})]},proxy:true}],null,false,1068209532)}):_vm._e(),_c('div',{staticClass:"workpackage-fontcolor-corner",style:(`background-color: ${_vm.opposite_text_color}`),on:{"click":function($event){return _vm.changeWorkPackageFontColor()}}})],1),_c('transition',{attrs:{"name":_vm.location === 'ProjectWallet' || _vm.isMobile ? 'subage-slide-in' : 'appear'}},[_c('router-view',{staticStyle:{"z-index":"10"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }